import { Record } from 'immutable';
export default class extends Record({
  active: null,
  completed: null,
  enrolled: null,
  succeeded: null
}, 'ContactListIds') {}